module.exports = __webpack_public_path__ + "img/opus9.4dd99d7f.jpg";